import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom"; // HashRouter as Router
import Main from "./page/Main";
import LayoutCom from "./layout/LayoutCom";
import ContactPag from "./page/Contact";
import PortfolioPag from "./page/Portfolio";
import ScrollToTop from "./component/ScrollToTop";

const App = () => {
  return (
    <div className="datafiveApp">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<LayoutCom />}>
            <Route path="/" element={<Main />} />
            <Route path="/contact" element={<ContactPag />} />
            <Route path="/portfolio" element={<PortfolioPag />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
